import React from 'react';
import { Link } from 'react-router-dom';


function Navigation() {
    return ( <
        nav >
        <
        ul className = 'navigation' >
        <
        li > < Link to = "/" > ABOUT ME < /Link></li >
        <
        li > < Link to = "/CV" > CV < /Link></li >
        <
        li > < Link to = "/Projects" > PROJECTS < /Link></li >
        <
        li > < Link to = "/Contacts" > CONTACTS < /Link></li >
        <
        /ul> <
        /nav>
    )
}
export default Navigation;